import React, { useState } from 'react';
import { Grid } from '@mui/material';
import styles from './updateBudget.module.scss';
import FormControl from '@mui/material/FormControl';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { object, string, ValidationError } from 'yup';
import Typography from '@mui/material/Typography';
import { CommonButton, CustomInputLabel, CustomMenuItem, CustomSelect, CustomTextFeild } from '../../common/StyledComponents/StyledFields';
import { apiRequest } from '../../../infrastructure/backendService';
import ToastComponent from '../../common/toastComponent';

interface ErrorMessageTypes {
   selectAmount: string;
   selectSubAmount: string;
   selectYear: string;
   budget: string;
}

const UpdateExpenseVoucher = (): JSX.Element => {
   const [formData, setFormData] = useState({
      selectAmount: '',
      selectSubAmount: '',
      selectYear: '',
      budget: '',
   });

   const [errorMessage, setErrorMessage] = useState<ErrorMessageTypes>({
      selectAmount: '',
      selectSubAmount: '',
      selectYear: '',
      budget: '',
   });

   const validationSchema = object().shape({
      selectAmount: string().required('select Amount is required'),
      selectSubAmount: string().required('select Sub Amount is required'),
      selectYear: string().required('select Year is required'),
      budget: string().required('budget is required'),
   });

   const handleFieldChange = (field: string, value: any): void => {
      setFormData({
         ...formData,
         [field]: value,
      });
   };


   const gothramList = [
      {
         label: 'label Name',
      },
      {
         label: 'label Name',
      },
      {
         label: 'label Name',
      },
      {
         label: 'label Name',
      },
      {
         label: 'label Name',
      },
      {
         label: 'label Name',
      },
   ];

   const customDropDown = (value: string, placeHolder: string, fieldName: string, errorText: string, listOfValues: object[]): React.ReactElement => {
      return (
         <FormControl className={styles.dropDowns}>
            <CustomSelect
               IconComponent={KeyboardArrowDownIcon}
               className={styles.dropDownSelect}
               id="grouped-select"
               placeholder={placeHolder}
               value={value}
               onChange={(e) => {
                  setErrorMessage({ ...errorMessage, [fieldName]: '' });
                  handleFieldChange(fieldName, e.target.value);
               }}
               MenuProps={{
                  PaperProps: {
                     sx: {
                        border: '1px solid #F05802',
                        '& ul': {
                           paddingTop: 0,
                           paddingBottom: 0,
                           overflowY: 'auto',
                           minHeight: 'auto',
                           maxHeight: '300px',
                           '&::-webkit-scrollbar': {
                              width: '8px',
                           },
                           '&::-webkit-scrollbar-thumb': {
                              background: '#F3C539',
                              borderRadius: '6px',
                           },
                        },
                     },
                  },
               }}
            >
               {listOfValues.map((item: any, index) => (
                  <CustomMenuItem key={index} value={item.label}>
                     {item.label}
                  </CustomMenuItem>
               ))}
            </CustomSelect>
            {errorText ? (
               <Typography sx={{ color: 'red', fontSize: '12px' }}>
                  {errorText}
               </Typography>
            ) : (
               ''
            )}
         </FormControl>
      );
   };

   const handleUpdate = async (): Promise<void> => {
      const errors: ErrorMessageTypes = {
         selectAmount: '',
         selectSubAmount: '',
         selectYear: '',
         budget: '',
      };

      try {
         // Validate the form data against the validation schema
         await validationSchema.validate(formData, { abortEarly: false });
         // If validation passes, you can submit the form
         setErrorMessage(errors);
         alert('Update Successful');
         // Call your API or perform other actions here
         //  updateApiCall();
      } catch (error: any) {
         // Handle validation errors

         if (error instanceof ValidationError) {
            error.inner.forEach((e: any) => {
               if (e.path) {
                  errors[e.path as keyof ErrorMessageTypes] = e.message;
               }
            });
         }
         setErrorMessage(errors);
      }
   };

   const updateApiCall = () => {
      const reqBody = {
         selectAmount: formData.selectAmount,
         selectSubAmount: formData.selectSubAmount,
         selectYear: formData.selectYear,
         budget: formData.budget
      }
      apiRequest({
         method: 'PUT',
         endpoint: '/',
         body: JSON.stringify(reqBody)
      })
      .then((res)=>{
         console.log(res)
         // const successMessage = 'Budget updated Successfully!'
         // toast.custom(<ToastSuccess message={successMessage} sent={""} />)
      })
      .catch((err)=>{
         console.log(err);
      //    const Errormessage: string = isNil(err.response)
      //     ? err.message
      //     : isNil(err.response.data)
      //     ? err.message
      //     : isNil(err.response.data.detail)
      //     ? `${err.response.data.error} ${err.response.data.status}`
      //     : isNil(err.response.data.errorMessage)
      //     ? `${err.response.data.detail} ${err.response.data.status}`
      //     : err.response.data.errorMessage;
      //   toast.custom(<ToastError message={Errormessage} />, {
      //     duration: 2000,
      //   });
      })
   }

   return (
      <>
      <ToastComponent/>
      <div>
         <div className={styles.BoxContainer}>
            <div className={styles.formContainer}>
               <Typography component="div" className={styles.typoGraphy}>
                  Add / Update Budgets
               </Typography>

               <Grid container spacing={2} sx={{ marginTop: '0px' }}>
                  <Grid item xs={12} sm={3}>
                     <CustomInputLabel>Select Amount</CustomInputLabel>
                     {customDropDown(formData.selectAmount, "Select Amount", 'selectAmount', errorMessage.selectAmount, gothramList)}
                  </Grid>
                  <Grid item xs={12} sm={3}>
                     <CustomInputLabel>Select Sub-Amount</CustomInputLabel>
                     {customDropDown(formData.selectSubAmount, "Select Sub-Amount", 'selectSubAmount', errorMessage.selectSubAmount, gothramList)}
                  </Grid>
               </Grid>
               <Grid container spacing={2} sx={{ marginTop: '0px' }}>
                  <Grid item xs={12} sm={3}>
                     <CustomInputLabel>Select Year</CustomInputLabel>
                     {customDropDown(formData.selectYear, "Select Year", 'selectYear', errorMessage.selectYear, gothramList)}
                  </Grid>
                  <Grid item xs={12} sm={3}>
                     <CustomInputLabel>Budget</CustomInputLabel>
                     <CustomTextFeild
                        className={styles.textField}
                        fullWidth
                        required
                        value={formData.budget}
                        onChange={(e) => {
                           setErrorMessage({ ...errorMessage, budget: '' });
                           handleFieldChange('budget', e.target.value);
                        }}
                        type='number'
                     />
                     {errorMessage.budget ? (
                        <Typography sx={{ color: 'red', fontSize: '12px' }}>
                           {errorMessage.budget}
                        </Typography>
                     ) : (
                        ''
                     )}
                  </Grid>
               </Grid>
            </div>
            <CommonButton sx={{ marginTop: '20px' }} onClick={handleUpdate}>Update</CommonButton>
         </div>
      </div>
      </>
   );
};

export default UpdateExpenseVoucher;
